import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Card() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Three.js", "Blender", "", "", "", ""];
    const infoProyect = [
        "Editable 3d card",
        "https://www.youtube.com/embed/A1_lhCVTglU",
        "On this page we can interact with this 3D card, change its color, texture and modify its position on the scene.",
        "https://brandongrimaldom.github.io/card/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Card;